import PageHandlersService from '@/utils/page-handlers-service';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';
import gsap, { Power2 } from 'gsap';
import { getOffsetTop } from '@/utils/dom';

const pageHandlers = new PageHandlersService();

const arrowSvgCode =
    '<svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.176 4.596L7.322 5.562L4.956 3.196V9.048H3.57V3.196L1.204 5.562L0.336 4.596L4.172 0.802H4.354L8.176 4.596Z" fill="white"></path></svg>';

const SORT_TEXT_BY_VALUE = {
    ['popular']: 'Популярные',
    ['dateup']: `По дате <span class="content-filters-sort__value-icon">${arrowSvgCode}</span>`,
    ['datedown']: `По дате <span class="content-filters-sort__value-icon down">${arrowSvgCode}</span>`,
};

const init = () => {
    let isSortModePicked = false;

    const sortButton = document.querySelector('.js-content-filters-sort-btn');
    const sortContainer = document.querySelector<HTMLElement>('.js-content-filters-sort');
    const sortSelectElement = document.querySelector<HTMLSelectElement>('.js-news-sort-select');
    const sortValues = document.querySelectorAll<HTMLElement>('.js-news-sort-value');
    const pickedModeElement = document.querySelector('.js-content-filters-sort-picked');
    const sortVariantsContainer = document.querySelector('.js-content-filters-variants');

    const emptySelectOptionElement = sortSelectElement?.querySelector<HTMLOptionElement>('.js-news-sort-option.empty');

    const mobilePopup = document.querySelector('.js-mobile-filter-popup');
    const mobilePopupCloseButtons = document.querySelectorAll('.js-mobile-filter-popup-close');
    const filtersForm = document.querySelector<HTMLFormElement>('.js-news-filters-form');
    const mobileFilterDependentElements = document.querySelectorAll('.js-mobile-filter-dependent');
    const filtersCountElements = document.querySelectorAll<HTMLElement>('.js-mobile-filters-count');
    const mobilePopupActionsReset = document.querySelector('.js-mobile-filter-popup-reset');
    const mobileSortValues = Array.from(document.querySelectorAll<HTMLElement>('.js-mobile-filter-popup-sort-value'));

    const currentFiltersValue = sortContainer?.dataset.currentValue;

    setTimeout(() => {
        if (DEVICE_WIDTH.isTablet && mobilePopup && sortButton) {
            gsap.set(mobilePopup, {
                top: sortButton.getBoundingClientRect().top - 25 + window.scrollY,
            });
        }
    });

    // Setting current filters value
    if (currentFiltersValue === 'popular' || currentFiltersValue === 'dateup' || currentFiltersValue === 'datedown') {
        const selectOption = sortSelectElement?.querySelector<HTMLOptionElement>(
            `.js-news-sort-option.${currentFiltersValue}`,
        );

        isSortModePicked = true;

        if (selectOption) {
            selectOption.selected = true;
            if (sortSelectElement) {
                sortSelectElement.value = selectOption.value;
            }

            sortSelectElement?.dispatchEvent(new Event('change'));
        }

        if (DEVICE_WIDTH.isDesktop) {
            sortContainer?.classList.add('picked');
            sortContainer?.classList.remove('opened');

            if (pickedModeElement) {
                pickedModeElement.innerHTML = SORT_TEXT_BY_VALUE[currentFiltersValue];
            }
            pickedModeElement?.classList.remove('hidden');
        } else {
            const activeFilterValue = mobileSortValues.find(
                (valueElement) => valueElement.dataset?.value === currentFiltersValue,
            );

            if (activeFilterValue) {
                activeFilterValue.classList.add('active');
            }
        }
    }

    // PC filters
    const handleSortButtonClick = (event: Event) => {
        if (DEVICE_WIDTH.isDesktop) {
            if (isSortModePicked) {
                event.stopPropagation();

                isSortModePicked = false;

                sortContainer?.classList.remove('picked');
                sortContainer?.classList.add('not-clickable');
                pickedModeElement?.classList.add('hidden');

                setTimeout(() => {
                    if (pickedModeElement) {
                        pickedModeElement.innerHTML = '';
                    }
                    sortContainer?.classList.remove('not-clickable');
                }, 400);
            } else {
                sortContainer?.classList.toggle('opened');
            }

            sortContainer?.classList.add('not-clickable');

            setTimeout(() => {
                sortContainer?.classList.remove('not-clickable');
            }, 400);
        } else {
            mobilePopup?.classList.add('active');

            document.body.classList.add('no-scroll');
        }
    };

    pageHandlers.set(sortButton, handleSortButtonClick);

    sortValues.forEach((value) => {
        const handleValueElementClick = (event: Event) => {
            event.stopPropagation();

            const selectOption = sortSelectElement?.querySelector<HTMLOptionElement>(
                `.js-news-sort-option.${value.dataset.value}`,
            );

            isSortModePicked = true;

            if (selectOption) {
                selectOption.selected = true;
                if (sortSelectElement) {
                    sortSelectElement.value = selectOption.value;
                }

                sortSelectElement?.dispatchEvent(new Event('change'));
            }

            sortContainer?.classList.add('picked');
            sortContainer?.classList.remove('opened');

            if (pickedModeElement) {
                pickedModeElement.innerHTML = value.innerHTML;
            }
            pickedModeElement?.classList.remove('hidden');
        };

        pageHandlers.set(value, handleValueElementClick);
    });

    const handlePickedElementClick = () => {
        if (isSortModePicked) {
            isSortModePicked = false;

            sortContainer?.classList.remove('picked');
            sortContainer?.classList.add('opened');

            if (emptySelectOptionElement) {
                emptySelectOptionElement.selected = true;
                if (sortSelectElement) {
                    sortSelectElement.value = '';
                }

                // sortSelectElement?.dispatchEvent(new Event('change'));
            }

            pickedModeElement?.classList.add('hidden');
            sortContainer?.classList.add('not-clickable');

            setTimeout(() => {
                if (pickedModeElement) {
                    pickedModeElement.innerHTML = '';
                }
                sortContainer?.classList.remove('not-clickable');
            }, 400);
        }
    };

    pageHandlers.set(sortVariantsContainer, handlePickedElementClick);

    if (DEVICE_WIDTH.isDesktop && sortContainer) {
        pageHandlers.set(
            sortSelectElement,
            () => {
                const scrollHeight = getOffsetTop(sortContainer) - 100;

                gsap.to(window, { scrollTo: scrollHeight, ease: Power2.easeInOut, duration: 1.2 });
            },
            'change',
        );
    }

    // Mobile filters
    if (!DEVICE_WIDTH.isDesktop) {
        const handleMobilePopupCloseClick = () => {
            mobilePopup?.classList.remove('active');

            document.body.classList.remove('no-scroll');
        };

        mobilePopupCloseButtons.forEach((button) => {
            pageHandlers.set(button, handleMobilePopupCloseClick);
        });

        const handleFormChange = () => {
            setTimeout(() => {
                const checkedInputsCount = filtersForm?.querySelectorAll('input:checked:not([value=""])').length;

                if (checkedInputsCount) {
                    mobileFilterDependentElements.forEach((elements) => {
                        elements.classList.add('filtered');
                    });

                    filtersCountElements.forEach((element) => {
                        element.innerText = `${checkedInputsCount}`;
                    });
                } else {
                    mobileFilterDependentElements.forEach((elements) => {
                        elements.classList.remove('filtered');
                    });

                    filtersCountElements.forEach((element) => {
                        element.innerText = '0';
                    });
                }
            });
        };

        pageHandlers.set(filtersForm, handleFormChange, 'change');

        const handleResetClick = () => {
            mobileFilterDependentElements.forEach((elements) => {
                elements.classList.remove('filtered');
            });

            filtersCountElements.forEach((element) => {
                element.innerText = '0';
            });
        };

        pageHandlers.set(mobilePopupActionsReset, handleResetClick);

        let activeSortMode = '';

        mobileSortValues.forEach((valueElement) => {
            const handleValueElementClick = () => {
                const value = valueElement.dataset.value;

                if (value) {
                    if (activeSortMode === value) {
                        const emptySelectOptionElement =
                            sortSelectElement?.querySelector<HTMLOptionElement>('.js-news-sort-option.empty');

                        if (emptySelectOptionElement) {
                            emptySelectOptionElement.selected = true;

                            activeSortMode = '';

                            mobileSortValues.forEach((value) => {
                                value.classList.remove('active');
                            });

                            sortSelectElement?.dispatchEvent(new Event('change'));
                        }
                    } else {
                        const selectOption = sortSelectElement?.querySelector<HTMLOptionElement>(
                            `.js-news-sort-option.${value}`,
                        );

                        if (selectOption) {
                            selectOption.selected = true;

                            if (sortSelectElement) {
                                sortSelectElement.value = selectOption.value;
                            }

                            activeSortMode = value;

                            mobileSortValues.forEach((value) => {
                                value.classList.remove('active');
                            });

                            valueElement.classList.add('active');
                            sortSelectElement?.dispatchEvent(new Event('change'));
                        }
                    }
                }
            };

            pageHandlers.set(valueElement, handleValueElementClick);
        });
    }
};

const destroy = () => {
    pageHandlers.clear();
};

const _module = { init, destroy };

export default _module;
